import { useTranslation } from "react-i18next";

const SelectLabeledText = ({ label }: { label: string }) => {
  const { t } = useTranslation();
  if (label?.toLowerCase() === "completed")
    return (
      <div className="w-fit bg-green-100 rounded-[10px] py-0.5 px-2.5 text-green-800 font-medium text-xs flex justify-center items-center">
        {t("constants.completed")}
      </div>
    );
  if (label?.toLowerCase() === "not_completed")
    return (
      <div className="w-fit bg-red-100 rounded-[10px] py-0.5 px-2.5 text-red-800 font-medium text-xs flex justify-center items-center">
        {t("constants.not_completed")}
      </div>
    );

  return (
    <div className="w-fit bg-yellow-100 rounded-[10px] py-0.5 px-2.5 text-yellow-800 font-medium text-xs flex justify-center items-center">
      {t("constants.not_checked")}
    </div>
  );
};

export default SelectLabeledText;
